import React from "react";
import { Popper } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../../stores/rootReducer";

import { useDrawsStyles } from "../Draws.styles";
import { DrawRequestStore } from "../../../stores/drawRequest/drawRequest.interface";
import {
  formatAuditTrailTimestamp,
  getAuditTrailDisplayName,
  getInitials
} from "../../AssetManagement.utils";
import { servicerStageHistoryInterface } from "../../../stores/servicerOnboarding/servicerOnboarding.interface";

export const StageAuditTrail = ({
  onboardingStatusHistory,
  anchorEl,
  open = true,
  onMouseEnter,
  onMouseLeave
}: {
  onboardingStatusHistory?: any[];
  anchorEl?: HTMLElement | null;
  open?: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}) => {
  const classes = useDrawsStyles();
  const { drawStageHistory } = useSelector<RootState, DrawRequestStore>(
    (state) => state.drawRequestStore
  );
  const genericHistoryData: any[] = onboardingStatusHistory || drawStageHistory;

  const auditTrailContent = (
    <div
      data-testid="stage-audit-trail"
      role="none"
      style={{ paddingTop: 6 }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className={classes.auditTrailParentDiv}>
        {genericHistoryData?.length > 0 ? (
          <div className={classes.auditTrailList}>
            {genericHistoryData.map(
              (row: servicerStageHistoryInterface, idx: number) => {
                const isLast = idx === genericHistoryData.length - 1;
                const displayName = getAuditTrailDisplayName(
                  row.updatedBy,
                  row.stageName || row.status
                );
                const timestamp = formatAuditTrailTimestamp(row.updatedTimeStamp);

                return (
                  <div
                    className={classes.auditTrailEntry}
                    key={`${row.updatedTimeStamp}_${idx}`}
                  >
                    <div className={classes.auditTrailRail}>
                      <span className={classes.bullet} />
                      {!isLast && (
                        <span className={classes.auditTrailRailLine} />
                      )}
                    </div>
                    <div className={classes.auditTrailContent}>
                      <div className={classes.auditTrailStage}>
                        {row.stageName || row.status}
                      </div>
                      {row.comment ? (
                        <div className={classes.auditCommentBlock}>
                          <span className={classes.auditTrailComment}>
                            Comment:
                          </span>{" "}
                          {row.comment}
                        </div>
                      ) : null}
                      <div className={classes.origDetails}>
                        <div className={classes.auditTrailavatar}>
                          {getInitials(
                            displayName === "Unknown" ? "" : displayName
                          )}
                        </div>
                        <div className={classes.auditTrailUserMeta}>
                          <span className={classes.personName}>
                            {displayName}
                          </span>
                          {timestamp ? (
                            <div className={classes.auditTrailTimestamp}>
                              <span>{timestamp.dateLine}</span>
                              <span>{timestamp.timeLine}</span>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              }
            )}
          </div>
        ) : (
          <div className={`${classes.auditCommentBlock} ${classes.noAuditData}`}>
            No Data Available
          </div>
        )}
      </div>
    </div>
  );

  if (anchorEl) {
    return (
      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="bottom-start"
        style={{ zIndex: 1300 }}
        modifiers={[
          {
            name: "offset",
            options: {
              offset: [0, 0]
            }
          },
          {
            name: "preventOverflow",
            enabled: true
          },
          {
            name: "flip",
            enabled: true
          }
        ]}
      >
        {auditTrailContent}
      </Popper>
    );
  }

  return (
    <div
      style={{
        position: "absolute",
        left: 0,
        top: "100%",
        right: "auto",
        zIndex: 999
      }}
    >
      {auditTrailContent}
    </div>
  );
};
